/* Kin Amora product page (template: product.kin-amora-pdp).
   Variant picker, gallery, sticky bar, tabs, FAQ, recommendations and recently viewed.
   Add to cart itself is handled by the Prestige <form is="product-form"> (cart drawer, counts, errors). */
(function () {
  'use strict';

  var MAX_QTY = 9;

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents, format) {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    format = format || settings.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(placeholder, value);
  }

  function parseFallbacks(text) {
    var map = {};
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split(':');
      if (parts.length === 2) map[parts[0].trim().toLowerCase()] = parts[1].trim().toLowerCase();
    });
    return map;
  }

  function sameOptions(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  /* ------------------------------------------------------------------ */
  /* Product (gallery + buy box + sticky bar)                            */
  /* ------------------------------------------------------------------ */
  function KaProduct(root) {
    var self = this;
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-ka-json]').textContent);
    this.form = document.getElementById(root.getAttribute('data-form-id'));
    this.variantInput = root.querySelector('[data-ka-variant-input]');
    this.qtyInput = root.querySelector('[data-ka-qty-input]');
    this.qtyValue = root.querySelector('[data-ka-qty-value]');
    this.track = root.querySelector('[data-ka-track]');
    this.thumbs = root.querySelector('[data-ka-thumbs]');
    this.counter = root.querySelector('[data-ka-counter]');
    this.prevBtn = root.querySelector('[data-ka-prev]');
    this.nextBtn = root.querySelector('[data-ka-next]');
    this.sticky = root.querySelector('[data-ka-sticky]');
    this.cta = root.querySelector('[data-ka-cta]');
    this.error = root.querySelector('[data-ka-error]');
    this.colorIndex = this.data.colorIndex;

    this.mediaById = {};
    this.data.media.forEach(function (m) { self.mediaById[m.id] = m; });
    this.colorNames = {};
    this.data.colors.forEach(function (c) { self.colorNames[c.toLowerCase()] = c; });
    this.lookIds = String(this.data.looks || '').split(',').filter(Boolean).map(Number);
    this.fallbacks = parseFallbacks(this.data.fallbacks);

    var currentId = Number(this.variantInput.value);
    this.variant = this.data.variants.filter(function (v) { return v.id === currentId; })[0] || this.data.variants[0];
    this.selected = this.variant.options.slice();
    this.qty = 1;
    this.index = 0;
    this.lockUntil = 0;
    this.target = null; // scrollLeft the gallery is sliding to after a click; scroll events are ignored until it gets there

    var plan = this.plan(this.colorIndex >= 0 ? this.selected[this.colorIndex] : '');
    this.shots = plan.ids;
    this.base = plan.base;

    this.bind();
    this.updateAvailability();
    this.updateQtyButtons();

    // Load every gallery photo once the page has loaded, so the next photo is ready before it slides in.
    if (document.readyState === 'complete') this.warmGallery();
    else window.addEventListener('load', function () { self.warmGallery(); });

    // A variant chosen through ?variant= may have its own photo further down the gallery.
    if (this.data.mode !== 'group' && this.variant.media) {
      var startIndex = this.shots.indexOf(this.variant.media);
      if (startIndex > 0) this.goTo(startIndex, false);
    }
  }

  KaProduct.prototype.plan = function (color) {
    var d = this.data, self = this;
    if (d.mode !== 'group') {
      return { ids: d.media.map(function (m) { return m.id; }), base: null };
    }
    var groups = [];
    d.media.forEach(function (m) { if (m.group && groups.indexOf(m.group) < 0) groups.push(m.group); });
    var sc = String(color || '').toLowerCase();
    var base = groups[0];
    if (groups.indexOf(sc) >= 0) {
      base = sc;
    } else if (this.fallbacks[sc] && groups.indexOf(this.fallbacks[sc]) >= 0) {
      base = this.fallbacks[sc];
    }
    var ids = [];
    d.media.forEach(function (m) { if (m.group === base) ids.push(m.id); });
    d.media.forEach(function (m) { if (!m.group) ids.push(m.id); });
    this.lookIds.forEach(function (id) { if (ids.indexOf(id) < 0 && self.mediaById[id]) ids.push(id); });
    return { ids: ids, base: base };
  };

  KaProduct.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var valueBtn = event.target.closest('[data-ka-value]');
      if (valueBtn && self.root.contains(valueBtn)) {
        var group = valueBtn.closest('[data-ka-option]');
        var optionIndex = group ? Number(group.getAttribute('data-ka-option')) : Number(valueBtn.getAttribute('data-ka-sticky-option'));
        self.selectOption(optionIndex, valueBtn.getAttribute('data-ka-value'));
        return;
      }
      var thumb = event.target.closest('[data-ka-thumb]');
      if (thumb) { self.goTo(Number(thumb.getAttribute('data-ka-thumb')), true); return; }
      if (event.target.closest('[data-ka-prev]')) { self.goTo(self.index - 1, true); return; }
      if (event.target.closest('[data-ka-next]')) { self.goTo(self.index + 1, true); return; }
      var qtyBtn = event.target.closest('[data-ka-qty]');
      if (qtyBtn) { self.setQty(self.qty + Number(qtyBtn.getAttribute('data-ka-qty'))); }
    });

    if (this.track) {
      this.track.addEventListener('scroll', function () {
        if (self.target !== null) {
          // A click started this slide: wait until it arrives (or a safety timeout passes) before reading positions.
          if (Math.abs(self.track.scrollLeft - self.target) <= 2 || Date.now() > self.lockUntil) self.target = null;
          return;
        }
        if (Date.now() < self.lockUntil) return;
        var width = self.track.clientWidth || 1;
        var idx = Math.max(0, Math.min(self.shots.length - 1, Math.round(self.track.scrollLeft / width)));
        if (idx !== self.index) { self.index = idx; self.updateActive(); }
      }, { passive: true });
      window.addEventListener('resize', function () {
        self.target = null;
        self.lockUntil = Date.now() + 120;
        self.track.scrollTo({ left: self.index * self.track.clientWidth });
      }, { passive: true });
    }

    if (this.form) {
      this.form.addEventListener('cart:error', function (event) {
        if (!self.error) return;
        self.error.textContent = (event.detail && event.detail.error) || 'This item could not be added to your cart.';
        self.error.hidden = false;
      });
      this.form.addEventListener('variant:add', function () { if (self.error) self.error.hidden = true; });
      this.form.addEventListener('submit', function () { if (self.error) self.error.hidden = true; });
    }

    if (this.sticky && this.cta) {
      var queued = false;
      var measure = function () {
        queued = false;
        var show = self.cta.getBoundingClientRect().bottom < 0;
        if (show === self.sticky.classList.contains('is-visible')) return;
        self.sticky.classList.toggle('is-visible', show);
        self.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        self.sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      };
      var onScroll = function () { if (!queued) { queued = true; requestAnimationFrame(measure); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }
  };

  KaProduct.prototype.findVariant = function (options) {
    return this.data.variants.filter(function (v) { return sameOptions(v.options, options); })[0] || null;
  };

  KaProduct.prototype.selectOption = function (optionIndex, value) {
    var options = this.selected.slice();
    options[optionIndex] = value;
    var variant = this.findVariant(options);
    if (!variant) {
      var matches = this.data.variants.filter(function (v) { return v.options[optionIndex] === value; });
      variant = matches.filter(function (v) { return v.available; })[0] || matches[0] || null;
    }
    if (variant) this.setVariant(variant);
  };

  KaProduct.prototype.selectVariantById = function (id) {
    var variant = this.data.variants.filter(function (v) { return v.id === Number(id); })[0];
    if (variant) this.setVariant(variant);
  };

  KaProduct.prototype.setVariant = function (variant) {
    var self = this;
    var ci = this.colorIndex;
    var previousColor = ci >= 0 ? this.selected[ci] : null;

    this.variant = variant;
    this.selected = variant.options.slice();
    this.variantInput.value = variant.id;

    // Pressed states (buy box + sticky swatches)
    this.root.querySelectorAll('[data-ka-value]').forEach(function (btn) {
      var group = btn.closest('[data-ka-option]');
      var oi = group ? Number(group.getAttribute('data-ka-option')) : Number(btn.getAttribute('data-ka-sticky-option'));
      btn.setAttribute('aria-pressed', btn.getAttribute('data-ka-value') === self.selected[oi] ? 'true' : 'false');
    });
    this.updateAvailability();

    var colorLabel = this.root.querySelector('[data-ka-option-value]');
    if (colorLabel && ci >= 0) colorLabel.textContent = this.selected[ci];

    // Price, compare-at price, pay-in-4 amount
    var price = this.root.querySelector('[data-ka-price]');
    if (price) price.innerHTML = formatMoney(variant.price);
    var compare = this.root.querySelector('[data-ka-compare]');
    if (compare) {
      var onSale = variant.compare > variant.price;
      compare.hidden = !onSale;
      if (onSale) compare.innerHTML = formatMoney(variant.compare);
    }
    this.root.querySelectorAll('[data-ka-installment]').forEach(function (el) {
      el.innerHTML = formatMoney(Math.floor(variant.price / 4));
    });

    // Buttons
    var label = variant.available ? 'Add to cart' : 'Sold out';
    this.root.querySelectorAll('[data-ka-atc], [data-ka-sticky-atc]').forEach(function (btn) {
      btn.disabled = !variant.available;
      btn.textContent = label;
    });
    var payment = this.root.querySelector('[data-ka-payment]');
    if (payment) payment.hidden = !variant.available;
    if (this.error) this.error.hidden = true;

    this.setQty(this.qty);

    // Sticky summary: color first, then the other options, then price
    var meta = this.root.querySelector('[data-ka-sticky-meta]');
    if (meta) {
      var bits = [];
      if (ci >= 0) bits.push(this.selected[ci]);
      this.selected.forEach(function (value, i) { if (i !== ci && value !== 'Default Title') bits.push(value); });
      meta.innerHTML = bits.map(esc).join(' · ') + (bits.length ? ' · ' : '') + formatMoney(variant.price);
    }

    // URL
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {}

    // Gallery
    if (this.data.mode === 'group') {
      if (ci >= 0 && previousColor !== this.selected[ci]) {
        var plan = this.plan(this.selected[ci]);
        this.base = plan.base;
        if (plan.ids.join(',') !== this.shots.join(',')) this.renderGallery(plan.ids);
        else this.goTo(0, false);
        this.updatePhotoNote();
      }
    } else if (variant.media) {
      var idx = this.shots.indexOf(variant.media);
      if (idx >= 0) this.goTo(idx, true);
    }
  };

  KaProduct.prototype.updatePhotoNote = function () {
    var note = this.root.querySelector('[data-ka-photo-note]');
    if (!note) return;
    var ci = this.colorIndex;
    var selectedColor = ci >= 0 ? String(this.selected[ci]).toLowerCase() : '';
    if (this.data.mode === 'group' && this.base && this.base !== selectedColor) {
      note.textContent = this.data.noteTemplate.replace('[color]', this.colorNames[this.base] || this.base);
      note.hidden = false;
    } else {
      note.hidden = true;
    }
  };

  KaProduct.prototype.updateAvailability = function () {
    var self = this;
    var variants = this.data.variants;
    this.root.querySelectorAll('[data-ka-value]').forEach(function (btn) {
      var group = btn.closest('[data-ka-option]');
      var oi = group ? Number(group.getAttribute('data-ka-option')) : Number(btn.getAttribute('data-ka-sticky-option'));
      var value = btn.getAttribute('data-ka-value');
      var available = variants.some(function (v) {
        if (!v.available || v.options[oi] !== value) return false;
        for (var i = 0; i < v.options.length; i++) {
          if (i !== oi && v.options[i] !== self.selected[i]) return false;
        }
        return true;
      });
      btn.classList.toggle('is-unavailable', !available);
    });
  };

  KaProduct.prototype.maxQty = function () {
    var max = this.variant && this.variant.max != null ? this.variant.max : MAX_QTY;
    return Math.max(1, Math.min(MAX_QTY, max));
  };

  KaProduct.prototype.setQty = function (qty) {
    this.qty = Math.max(1, Math.min(this.maxQty(), qty));
    if (this.qtyInput) this.qtyInput.value = this.qty;
    if (this.qtyValue) this.qtyValue.textContent = this.qty;
    this.updateQtyButtons();
  };

  KaProduct.prototype.updateQtyButtons = function () {
    var dec = this.root.querySelector('[data-ka-qty="-1"]');
    var inc = this.root.querySelector('[data-ka-qty="1"]');
    if (dec) dec.disabled = this.qty <= 1;
    if (inc) inc.disabled = this.qty >= this.maxQty();
  };

  KaProduct.prototype.renderGallery = function (ids) {
    var self = this;
    var title = this.data.productTitle;
    this.shots = ids;
    this.index = 0;

    if (this.thumbs) {
      this.thumbs.innerHTML = ids.map(function (id, i) {
        var m = self.mediaById[id];
        var label = esc(m.caption || title);
        return '<button type="button" class="ka-thumb' + (i === 0 ? ' is-active' : '') + '" data-ka-thumb="' + i + '" aria-label="' + label + '" title="' + label + '">' +
          '<img src="' + esc(m.thumb) + '" alt="" loading="lazy" width="80" height="100"></button>';
      }).join('');
    }

    if (this.track) {
      this.track.innerHTML = ids.map(function (id, i) {
        var m = self.mediaById[id];
        var alt = esc(title + (m.caption ? ', ' + m.caption : ''));
        return '<figure class="ka-shot" data-ka-shot="' + i + '">' +
          '<img src="' + esc(m.src) + '" srcset="' + esc(m.srcset) + '" sizes="(max-width: 899px) 100vw, 52vw" alt="' + alt + '" width="' + m.w + '" height="' + m.h + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
          (m.caption ? '<figcaption>' + esc(m.caption) + '</figcaption>' : '') + '</figure>';
      }).join('');
      this.target = null;
      this.lockUntil = Date.now() + 120;
      this.track.scrollTo({ left: 0 });
      this.warmGallery();
    }

    var multiple = ids.length > 1;
    if (this.prevBtn) this.prevBtn.hidden = !multiple;
    if (this.nextBtn) this.nextBtn.hidden = !multiple;

    var stickyImg = this.root.querySelector('.ka-sticky__img');
    if (stickyImg && ids.length) {
      stickyImg.src = this.mediaById[ids[0]].sticky;
      stickyImg.removeAttribute('srcset');
    }
    this.updateActive();
  };

  KaProduct.prototype.goTo = function (i, smooth) {
    var n = this.shots.length;
    if (!n || !this.track) return;
    var idx = ((i % n) + n) % n;
    this.index = idx;
    var left = idx * this.track.clientWidth;
    if (Math.abs(this.track.scrollLeft - left) <= 2) { this.target = null; this.updateActive(); return; }
    this.target = left;
    this.lockUntil = Date.now() + (smooth ? 1500 : 200);
    this.track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    this.updateActive();
  };

  KaProduct.prototype.warmGallery = function () {
    if (!this.track) return;
    this.track.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  };

  KaProduct.prototype.updateActive = function () {
    var self = this;
    if (this.thumbs) {
      var active = null;
      this.thumbs.querySelectorAll('[data-ka-thumb]').forEach(function (thumb) {
        var on = Number(thumb.getAttribute('data-ka-thumb')) === self.index;
        thumb.classList.toggle('is-active', on);
        if (on) active = thumb;
      });
      // Keep the active thumbnail visible in the rail (horizontal on phones, vertical on desktop).
      if (active && this.thumbs.scrollWidth > this.thumbs.clientWidth + 1) {
        var left = active.offsetLeft - this.thumbs.offsetLeft - (this.thumbs.clientWidth - active.clientWidth) / 2;
        this.thumbs.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      } else if (active && this.thumbs.scrollHeight > this.thumbs.clientHeight + 1) {
        var top = active.offsetTop - this.thumbs.offsetTop - (this.thumbs.clientHeight - active.clientHeight) / 2;
        this.thumbs.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }
    if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + this.shots.length;
  };

  /* ------------------------------------------------------------------ */
  /* Tabs                                                                */
  /* ------------------------------------------------------------------ */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ka-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ka-panel]'));
    var track = root.querySelector('.ka-tabs__track');
    if (!tabs.length) return;

    function select(name, focus) {
      var found = tabs.some(function (t) { return t.getAttribute('data-ka-tab') === name; });
      if (!found) return false;
      tabs.forEach(function (tab, i) {
        var on = tab.getAttribute('data-ka-tab') === name;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on) {
          if (track) track.style.setProperty('--ka-tab-index', i);
          if (focus) tab.focus();
        }
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-ka-panel') === name;
        if (on && panel.hidden) {
          panel.hidden = false;
          panel.classList.remove('is-entering');
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        } else if (!on) {
          panel.hidden = true;
        }
      });
      return true;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab.getAttribute('data-ka-tab'), false); });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (next) { event.preventDefault(); select(next.getAttribute('data-ka-tab'), true); }
      });
    });

    root.kaSelectTab = select;
  }

  function openTab(name) {
    var tabsRoot = document.querySelector('[data-ka-tabs]');
    if (!tabsRoot || !tabsRoot.kaSelectTab) return false;
    if (!tabsRoot.kaSelectTab(name, false)) return false;
    var target = document.getElementById('ka-details');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  /* ------------------------------------------------------------------ */
  /* FAQ                                                                 */
  /* ------------------------------------------------------------------ */
  function initFaq(root) {
    root.addEventListener('click', function (event) {
      var button = event.target.closest('.ka-faq__q');
      if (!button || !root.contains(button)) return;
      var open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      var answer = document.getElementById(button.getAttribute('aria-controls'));
      if (answer) answer.classList.toggle('is-open', open);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Recommendations + recently viewed                                   */
  /* ------------------------------------------------------------------ */
  function removeSection(el) {
    var section = el.closest('.shopify-section');
    if (section) section.remove(); else el.remove();
  }

  function initRecs(el) {
    fetch(el.getAttribute('data-ka-recs-url'), { priority: 'low' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = doc.querySelector('[data-ka-recs-results]');
        if (results) el.replaceWith(document.importNode(results, true));
        else removeSection(el);
      })
      .catch(function () { removeSection(el); });
  }

  function initRecent(el) {
    var exclude = Number(el.getAttribute('data-exclude'));
    var ids = [];
    try { ids = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]'); } catch (e) {}
    ids = ids.filter(function (id) { return id !== exclude; }).slice(0, 8);
    if (!ids.length) { removeSection(el); return; }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = root + 'search?type=product&q=' + encodeURIComponent(query) + '&section_id=' + encodeURIComponent(el.getAttribute('data-section-id'));
    fetch(url, { priority: 'low' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = doc.querySelector('[data-ka-recent-results]');
        if (results && results.children.length) el.replaceWith(document.importNode(results, true));
        else removeSection(el);
      })
      .catch(function () { removeSection(el); });
  }

  /* ------------------------------------------------------------------ */
  /* REVIEWS.io product reviews widget (loaded when the section nears)    */
  /* ------------------------------------------------------------------ */
  var scriptPromises = {};
  function loadScript(src) {
    if (!scriptPromises[src]) {
      scriptPromises[src] = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return scriptPromises[src];
  }

  function reviewsIoConfig(el) {
    var skus = el.getAttribute('data-skus');
    return {
      store: el.getAttribute('data-store'),
      widget: 'polaris',
      options: {
        types: 'product_review',
        enable_sentiment_analysis: false,
        include_sentiment_preview: false,
        per_page: Number(el.getAttribute('data-per-page')) || 8,
        store_review: { hide_if_no_results: false },
        third_party_review: { hide_if_no_results: false },
        product_review: { sku: skus, hide_if_no_results: false },
        questions: {
          hide_if_no_results: true, enable_ask_question: false, enable_ask_question_button_style: false,
          show_dates: true, include_qna_structured_data: false, grouping: skus
        },
        header: {
          enable_summary: true, enable_ratings: true, enable_attributes: true, enable_image_gallery: true,
          enable_percent_recommended: false, enable_write_review: true, enable_ask_question: false,
          overall_rating_style: 'outof5', image_thumbnail_size: 'large', rating_decimal_places: 1,
          enable_sub_header: true, use_write_review_button: true, enable_if_no_results: true,
          show_review_title_field: true
        },
        sentiment: { badge_text: 'Our Customers Say', enable_rating_breakdown: false },
        filtering: {
          enable: true, enable_text_search: true, enable_overall_rating_filter: true, enable_language_filter: false,
          enable_language_filter_language_change: false, enable_ratings_filters: true, enable_attributes_filters: true,
          enable_expanded_filters: false, enable_sorting: true, enable_product_filter: false, enable_media_filter: true
        },
        reviews: {
          enable_share: false, enable_helpful_vote: true, enable_helpful_display: true, enable_report: true,
          enable_date: true, enable_images: true, enable_ratings: true, image_thumbnail_size: 'large',
          enable_attributes: true, enable_verified_badge: true, verified_badge_position: '', enable_subscriber_badge: true,
          enable_avatar: true, enable_reviewer_name: true, enable_product_name: true, enable_link_product: false,
          enable_reviewer_address: true, reviewer_address_format: 'country', enable_reviewer_recommends: true,
          enable_third_party_source: true, combine_title_stars: false, show_untranslated: false
        },
        avatars: { enable_gravatar: false, gravatar_fallback: 'identicon' }
      },
      styles: {
        '--base-font-size': '15px',
        '--common-button-font-family': 'inherit',
        '--common-button-font-size': '11.5px',
        '--common-button-font-weight': '400',
        '--common-button-letter-spacing': '0.16em',
        '--common-button-text-transform': 'uppercase',
        '--common-button-vertical-padding': '15px',
        '--common-button-horizontal-padding': '30px',
        '--common-button-border-width': '1px',
        '--common-button-border-radius': '0px',
        '--primary-button-bg-color': '#121212',
        '--primary-button-border-color': '#121212',
        '--primary-button-text-color': '#ffffff',
        '--secondary-button-bg-color': 'transparent',
        '--secondary-button-border-color': '#121212',
        '--secondary-button-text-color': '#121212',
        '--common-star-color': '#E8A317',
        '--medium-star-size': '20px',
        '--small-star-size': '16px',
        '--heading-text-color': '#121212',
        '--heading-text-font-weight': '400',
        '--heading-text-font-family': 'var(--ka-serif)',
        '--heading-text-letter-spacing': '0',
        '--heading-text-transform': 'none',
        '--body-text-color': 'rgba(18,18,18,0.72)',
        '--body-text-font-weight': '400',
        '--body-text-line-height': '170%',
        '--body-text-font-family': 'inherit',
        '--body-text-letter-spacing': '0',
        '--body-text-transform': 'none',
        '--inputfield-text-font-family': 'inherit',
        '--input-text-font-size': '14px',
        '--inputfield-text-font-weight': '400',
        '--inputfield-text-color': '#121212',
        '--inputfield-border-color': 'rgba(18,18,18,0.25)',
        '--inputfield-background-color': 'transparent',
        '--inputfield-border-width': '1px',
        '--inputfield-border-radius': '0px',
        '--common-border-color': 'rgba(18,18,18,0.14)',
        '--common-border-width': '1px',
        '--common-sidebar-width': '190px',
        '--filters-panel-bg-color': 'transparent',
        '--filters-panel-font-size': '14px',
        '--filters-panel-star-size': '14px',
        '--slider-indicator-bg-color': 'rgba(18,18,18,0.1)',
        '--slider-indicator-button-color': '#121212',
        '--slider-indicator-width': '350px',
        '--badge-icon-color': '#121212',
        '--badge-text-color': '#121212',
        '--badge-text-transform': 'none',
        '--author-font-size': 'inherit',
        '--author-text-transform': 'none',
        '--avatar-thumbnail-size': '48px',
        '--avatar-thumbnail-border-radius': '100px',
        '--avatar-thumbnail-text-color': '#121212',
        '--avatar-thumbnail-bg-color': '#F1EEE9',
        '--photo-video-thumbnail-size': '72px',
        '--pagination-tab-active-text-color': '#121212',
        '--pagination-tab-active-text-font-weight': '400',
        '--pagination-tab-active-border-color': '#121212',
        '--pagination-tab-border-width': '2px'
      }
    };
  }

  function initReviewsIo(el) {
    if (el.kaReviewsReady) return;
    el.kaReviewsReady = true;
    var started = false;
    var start = function () {
      if (started) return;
      started = true;
      loadScript('https://widget.reviews.co.uk/polaris/build.js').then(function () {
        if (typeof window.ReviewsWidget !== 'function') return;
        new window.ReviewsWidget('#' + el.id, reviewsIoConfig(el));
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { observer.disconnect(); start(); }
      }, { rootMargin: '800px 0px' });
      observer.observe(el);
    } else {
      start();
    }
  }

  /* ------------------------------------------------------------------ */
  /* Init                                                                */
  /* ------------------------------------------------------------------ */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ka-product]').forEach(function (root) {
      if (!root.kaProduct) root.kaProduct = new KaProduct(root);
    });
    scope.querySelectorAll('[data-ka-tabs]').forEach(function (root) {
      if (!root.kaSelectTab) initTabs(root);
    });
    scope.querySelectorAll('[data-ka-faq]').forEach(function (root) {
      if (!root.kaFaqReady) { root.kaFaqReady = true; initFaq(root); }
    });
    scope.querySelectorAll('[data-ka-reviews-io]').forEach(initReviewsIo);
    scope.querySelectorAll('[data-ka-recs-url]').forEach(initRecs);
    scope.querySelectorAll('[data-ka-recent]').forEach(initRecent);
  }

  document.addEventListener('click', function (event) {
    var tabLink = event.target.closest('[data-ka-open-tab]');
    if (tabLink && openTab(tabLink.getAttribute('data-ka-open-tab'))) {
      event.preventDefault();
      return;
    }

    var lookBtn = event.target.closest('[data-ka-select-variant]');
    if (lookBtn) {
      var productRoot = document.querySelector('[data-ka-product]');
      if (productRoot && productRoot.kaProduct) {
        productRoot.kaProduct.selectVariantById(lookBtn.getAttribute('data-ka-select-variant'));
        var buy = productRoot.querySelector('.ka-buy');
        if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    var menuToggle = event.target.closest('[data-ka-menu-toggle]');
    if (menuToggle) {
      var drawer = document.getElementById(menuToggle.getAttribute('aria-controls'));
      var open = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (drawer) drawer.classList.toggle('is-open', open);
    }
  });

  init(document);

  var hashTabs = { '#ka-size-fit': 'size', '#ka-shipping-returns': 'ship' };
  if (hashTabs[window.location.hash]) openTab(hashTabs[window.location.hash]);
  window.addEventListener('hashchange', function () {
    if (hashTabs[window.location.hash]) openTab(hashTabs[window.location.hash]);
  });

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
